export const heroData = {
  title: "Sarah Chun",
  
  subtitle: "Game Developer with 6 years of Professional Game Industry Experience",
  
  description: "Building games, interactive experiences, and tools. Thriving on diverse projects and solving complex problems in fast-paced environments. Passionate about creating robust tools to streamline workflows.",
  
  buttons: [
    {
      text: "Download Resume",
      type: "secondary",
      action: "download",
      icon: "Download"
    },
    {
      text: "View My Work",
      type: "primary",
      action: "scroll",
      target: "projects"
    },
    {
      text: "Get In Touch",
      type: "secondary",
      action: "scroll",
      target: "contact"
    }
  ],
  
  resume: {
    filename: "Resume_SarahChun.pdf",
    path: "/Resume_SarahChun.pdf"
  }
}; 